export function getParam(key: string): string | null {
  if (typeof window === `undefined`) return null;
  return new URLSearchParams(window.location.search).get(key);
}

export function getList(key: string): string[] {
  return getParam(key)?.split(`,`).filter(Boolean) ?? [];
}

export function setParam(key: string, value: string | null): void {
  if (typeof window === `undefined`) return;
  const params = new URLSearchParams(window.location.search);
  if (value) params.set(key, value);
  else params.delete(key);
  const newUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname;
  window.history.replaceState(null, ``, newUrl);
}

export function toggleInList(key: string, value: string, on: boolean): void {
  const current = new Set(getList(key));
  if (on) current.add(value);
  else current.delete(value);
  setParam(key, current.size ? Array.from(current).join(`,`) : null);
}
